import Token from '@/utils/Token';

export default {
    caixa(projetoId) {
        return axios.get(`/api/auth/minha-caixa/${projetoId}`, Token.getHeader());
    },
    count(projetoId) {
        return axios.get(`/api/auth/minha-caixa/${projetoId}/count`, Token.getHeader());
    },
};
